var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1704 13.0663C10.1752 13.2041 10.1805 13.3377 10.1856 13.4672C10.1929 13.6533 10.2 13.8308 10.2045 13.9997H13.9998V11.8997C13.9998 10.0377 10.8906 9.33301 9.3331 9.33301C9.1352 9.33301 8.91226 9.34438 8.67383 9.36806C9.01219 9.62895 9.30735 9.93057 9.54323 10.2714C11.0964 10.3446 13.1104 11.1911 13.222 11.6663V13.0663H10.1704Z",
    fill: "black",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53758 7.14392C8.46202 7.41795 8.34973 7.66671 8.19299 7.86918C8.53031 8.05863 8.9195 8.16667 9.33392 8.16667C10.6226 8.16667 11.6673 7.122 11.6673 5.83333C11.6673 4.54467 10.6226 3.5 9.33392 3.5C8.84642 3.5 8.39385 3.6495 8.01953 3.90515C8.17814 4.1268 8.31143 4.36531 8.4117 4.60822C8.66835 4.41472 8.98774 4.3 9.33392 4.3C10.1808 4.3 10.8673 4.9865 10.8673 5.83333C10.8673 6.68017 10.1808 7.36667 9.33392 7.36667C9.0423 7.36667 8.76969 7.28526 8.53758 7.14392Z",
    fill: "black",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.2663C6.24167 10.2663 8.43889 11.1693 8.55556 11.6663V13.0663H0.777778V11.6663C0.894445 11.1623 3.09167 10.2663 4.66667 10.2663ZM4.66667 9.33301C3.10917 9.33301 0 10.0377 0 11.8997V13.9997H9.33333V11.8997C9.33333 10.0377 6.22417 9.33301 4.66667 9.33301Z",
    fill: "black",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18333 5.24967C7.18333 6.63959 6.05658 7.76634 4.66667 7.76634C3.27675 7.76634 2.15 6.63959 2.15 5.24967C2.15 3.85976 3.27675 2.73301 4.66667 2.73301C6.05658 2.73301 7.18333 3.85976 7.18333 5.24967Z",
    stroke: "black",
    strokeOpacity: 0.55,
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.589fd862.svg";
export { ForwardRef as ReactComponent };